import { useEffect, useRef, useState, useMemo, useOptimistic } from "react"
import { FiFilter } from "react-icons/fi"
import { getApiInstance } from "../../../utils/api"
import InputSearch from "../../../components/inputs/inputSearch/inputSearch"
import Button from "../../../components/button/button"
import Modal from "../../../components/modal/modal"
import Input from "../../../components/inputs/input/input"
import Notification from "../../../components/notification/notification"
import TableEditable from "../../../components/tableEditable/tableEditable"
import SectionHeader from "../../../components/sectionHeader/sectionHeader"
import Badge from "../../../components/badge/badge"
import InputDropdown from "../../../components/inputs/inputDropdown/inputDropdown"
import Tag from "../../../components/tag/tag"
import Accordion from "../../../components/accordion/accordion"
import { TbLocationDollar } from "react-icons/tb"
import { columns } from "../../maestroDotaciones/data/data"
import { BiExport } from "react-icons/bi"
import { BiImport } from "react-icons/bi"
import { BiDownload } from "react-icons/bi"
import { searchByKeywords } from "../../../utils/searchUtils";
import DateRangeCalendar from "../../../components/dateRangeCalendar/dateRangeCalendar";

const estadoLabels = {
	1: "Pendiente de información",
	2: "Informado",
	3: "Proposición de nueva tarifa",
	4: "Rechazada pendiente de revisión",
	5: "Informado después de revisión",
	6: "Aprobada Atlante",
	7: "Aceptado",
	8: "Rechazado",
	9: "Desestimado"
}

const estados = [
	{ id: 1, label: "Pendiente de información" },
	{ id: 2, label: "Informado" },
	{ id: 3, label: "Proposición de nueva tarifa" },
	{ id: 4, label: "Rechazada pendiente de revisión" },
	{ id: 5, label: "Informado después de revisión" },
	{ id: 6, label: "Aprobada Atlante" },
	{ id: 7, label: "Aceptado" },
	{ id: 8, label: "Rechazado" },
	{ id: 9, label: "Desestimado" }
]

const statesNoEdit = []

export default function DashboardProveedor({ user }) {
	const [searchTerm, setSearchTerm] = useState("")
	const [solicitudes, setSolicitudes] = useState([])
	const [tableEditMode, setTableEditMode] = useState(false)
	const [selectedSolicitudes, setSelectedSolicitudes] = useState([])
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [editSolicitud, setEditSolicitud] = useState(null)
	const [filterMuebles, setFilterMuebles] = useState([])
	const [filterNombreTarifa, setFilterNombreTarifa] = useState([])
	const [filterEstado, setFilterEstado] = useState([])
	const [filterFechaInformado, setFilterFechaInformado] = useState([])
	const [filterDiasRestantes, setFilterDiasRestantes] = useState([])
	const [mueblesOptions, setMueblesOptions] = useState([])
	const [tarifasOptions, setTarifasOptions] = useState([])
	const [estadosOptions, setEstadosOptions] = useState(estados)
	const [usedFilter, setUsedFilter] = useState()
	const [isFiltersModalOpen, setIsFiltersModalOpen] = useState(false)
	const notificationRef = useRef(null)
	const [filteredSolicitudes, setFilteredSolicitudes] = useState([]);
	const [categorias, setCategorias] = useState([]);
	const [subCategorias, setSubcategorias] = useState([]);
    const [filterCategoria, setFilterCategoria] = useState([]);
    const [filterSubcategoria, setFilterSubcategoria] = useState([]);
    const [filterFechaSolicitud, setFilterFechaSolicitud] = useState({
        startDate: null,
        endDate: null,
    });


	const columnsTarifas = [
		{
			key: "estado",
			label: "Estado",
			render: (row) => {
				let variant
				const estadoLegible = estadoLabels[row.codEstado] || "Sin estado"

				switch (row.estado) {
					case 1: // Pendiente
						if (row.diasRestantes <= 0) {
							variant = "danger"
						} else {
							variant = "default"
						}
						break
					case 2: // Informado
						variant = "info"
						break
					case 3: // Proposición de nueva tarifa
						variant = "info"
						break
					case 4: // Rechazado pendiente revisión
						variant = "warning"
						break
					case 5: // Informado después de revisión
						variant = "info"
						break
					case 6: // Revisado pendiente aceptación
						variant = "success"
						break
					case 7: // Aceptado
						variant = "success"
						break
					case 8: // Rechazado
						variant = "danger"
						break
					case 9: // Desestimado
						variant = "danger"
						break
					default:
						variant = "default"
				}

				return <Badge label={estadoLegible} variant={variant} />
			},
			editable: false
		},
		{
			key: "diasRestantes",
			label: "Días Restantes",
			type: "number",
			editable: false,
			highlightDays: true
		},
		{
			key: "rutaImagenMueble",
			label: "Imagen",
			render: (row) => (
				<img
					src={row.rutaImagenMueble || "defaultImage.png"}
					alt={row.nombreMueble || "Sin nombre"}
					style={{
						maxWidth: "48px",
						maxHeight: "48px",
						overflow: "hidden",
						textOverflow: "ellipsis"
					}}
				/>
			),
			editable: false
		},
		{ key: "nombreMueble", label: "Mueble", editable: false },
		{ key: "referencia", label: "Referencia", editable: false },
		{ key: "medida", label: "Unidades", editable: false },
		{ key: "nombreTarifa", label: "Nombre tarifa", editable: false },
		{
			key: "referenciaTarifaGOI",
			label: "Referencia Tarifa GOI",
			editable: true,
			required: false
		},
		{
			key: "precioUnidad",
			label: "Precio Unidad",
			type: "number",
			editable: (row) =>
				!(
					row.costeFabricacion !== 0 &&
					row.costeMateriales !== 0 &&
					row.costeMaquinaria !== 0 &&
					row.costeManoObra !== 0 &&
					row.porcentajeBeneficioSobreCoste !== 0
				),
			required: true,
			render: (row) => {
				let precioProveedor
				if (
					row.costeFabricacion !== 0 &&
					row.costeMateriales !== 0 &&
					row.costeMaquinaria !== 0 &&
					row.costeManoObra !== 0 &&
					row.porcentajeBeneficioSobreCoste !== 0
				) {
					precioProveedor = parseFloat(
						(row.costeFabricacion +
							row.costeMateriales +
							row.costeMaquinaria +
							row.costeManoObra) *
							(1 + row.porcentajeBeneficioSobreCoste / 100)
					).toFixed(2)
				} else {
					precioProveedor = row.precioUnidad === 0 ? "-" : row.precioUnidad
				}

				if (row.precioUnidadPropuesto && row.precioUnidadPropuesto !== 0) {
					const porcentajeDiferencia = (
						((row.precioUnidadPropuesto - precioProveedor) / precioProveedor) *
						100
					).toFixed(2)

					return (
						<div style={{ display: "flex", flexDirection: "column" }}>
							<span style={{ marginBottom: "4px" }}>
								{typeof precioProveedor === "number"
									? precioProveedor
									: precioProveedor}{" "}
								{row.simbolo}
							</span>
							<span
								style={{
									color: "#ffa30f",
									fontSize: "1.4rem",
									borderTop: "1px dashed #ffa30f",
									paddingTop: "4px",
									display: "flex",
									alignItems: "center"
								}}
							>
								<span
									style={{
										marginRight: "5px",
										fontWeight: "700"
									}}
								>
									Propuesta:
								</span>
								<span>
									{row.precioUnidadPropuesto} {row.simbolo}
								</span>
								<span
									style={{
										marginLeft: "8px",
										fontSize: "1.2rem",
										fontWeight: "700",
										backgroundColor:
											porcentajeDiferencia < 0 ? "#ffe3e3" : "#d9fcec",
										color: porcentajeDiferencia < 0 ? "#db3737" : "#2dbf7c",
										padding: "2px 6px",
										borderRadius: "4px"
									}}
								>
									{porcentajeDiferencia}%
								</span>
							</span>
						</div>
					)
				}

				return `${
					typeof precioProveedor === "number"
						? precioProveedor
						: precioProveedor
				} ${row.simbolo}`
			}
		},
		{
			key: "comentariosProveedor",
			label: "Comentarios Proveedor",
			type: "number",
			editable: true
		},
		{
			key: "fechaSolicitud",
			label: "Fecha Solicitud",
			render: (row) => {
				const date = new Date(row.fechaSolicitud)
				return date.toLocaleDateString()
			},
			editable: false
		},
		{ key: "plazo", label: "Plazo", type: "number", editable: false },
		{
			key: "showAll",
			label: "Desglosar precios",
			render: (row) => (
				<Button
					label="Desglosar precios"
					onClick={() => handleOpenEditSolicitud(row)}
				/>
			)
		}
	]

	useEffect(() => {
		fetchSolicitudes()
	}, [])

	const fetchSolicitudes = async () => {
	const api = getApiInstance();
	try {
		const response = await api.post(
			`/api/MueblesPrecios/GetMueblesPrecioByProveedorEstados/${user.codEmpresa}`,
			[1, 4, 5, 6, 7, 8]
		);

		const filtradas = response.data.filter(
			(solicitud) =>
				![5, 6, 7, 8].includes(solicitud.codEstado)
		);

		setSolicitudes(filtradas);
		setFilteredSolicitudes(filtradas); 
	} catch (error) {
		console.error("Error al obtener las solicitudes:", error);
		setSolicitudes([]);
		setFilteredSolicitudes([]);
	}
};

	useEffect(() => {
		// A partir del conjunto filtrado, se recalculan las opciones disponibles.
		// Muebles:
		if (usedFilter !== "mueble") {
			setMueblesOptions(
				Array.from(
					new Map(
						filteredSolicitudes.map((solicitud) => [
							solicitud.codMueble,
							{
								id: solicitud.codMueble,
								nombre: solicitud.referencia
							}
						])
					).values()
				)
			)
		}

		// Tarifas:
		if (usedFilter !== "nombreTarifa") {
			setTarifasOptions(
				Array.from(
					new Map(
						filteredSolicitudes.map((solicitud) => [
							solicitud.nombreTarifa,
							{
								id: solicitud.nombreTarifa,
								nombre: solicitud.nombreTarifa
							}
						])
					).values()
				)
			)
		}

		// Estados (suponiendo que solicitud.estado tiene el valor que quieres mostrar):
		if (usedFilter !== "estado") {
			setEstadosOptions(
				Array.from(
					new Map(
						filteredSolicitudes.map((solicitud) => [
							solicitud.estado,
							{
								id: solicitud.estado,
								nombre: estados.find((estado) => estado.id === solicitud.estado)
									.label
							}
						])
					).values()
				)
			)
		}
	}, [filteredSolicitudes])

	const handleUpdateSolicitud = async (solicitud) => {
		const api = getApiInstance()
		try {
			await api.put(`/api/MueblesPrecios`, solicitud)
			notificationRef.current.addNotification(
				"Solicitudes actualizadas correctamente.",
				"success"
			)
		} catch (error) {
			console.error("Error al actualizar la solicitud:", error)
			notificationRef.current.addNotification(
				"Hubo un error al actualizar la solicitud.",
				"error"
			)
		}
	}

	const handleBulkUpdate = async (solicitudes) => {
		const api = getApiInstance()
		try {
			await api.put("/api/MueblesPrecios/bulk-update", solicitudes)
			notificationRef.current.addNotification(
				"Solicitudes actualizadas correctamente.",
				"success"
			)

			setSolicitudes((prevSolicitudes) =>
				prevSolicitudes.map((solicitud) => {
				  const actualizada = solicitudes.find(
					(item) => item.codPrecioMueble === solicitud.codPrecioMueble
				  );
				  // Si existe una actualización para esta solicitud, la fusiona (o se la reemplaza)
				  return actualizada ? { ...solicitud, ...actualizada } : solicitud;
				})
			  );

		} catch (error) {
			console.error("Error en actualización masiva:", error)
			notificationRef.current.addNotification(
				"Hubo un error al actualizar la solicitud.",
				"error"
			)
		}
	}

	const handlePatchCellUpdate = async (muebleId, field, value) => {
		const api = getApiInstance()
		// Construimos el documento JSON Patch: un arreglo de operaciones
		const patchDoc = [{ op: "replace", path: `/${field}`, value }]

		try {
			console.log("Actualizando campo:", patchDoc)
			const response = await api.patch(
				`/api/MueblesPrecios/${muebleId}`,
				patchDoc,
				{
					headers: {
						"Content-Type": "application/json-patch+json"
					}
				}
			)

			// Comprobamos si la respuesta fue exitosa (código 2xx)
			if (response.status >= 200 && response.status < 300) {
				// Notificación de éxito
				solicitudes.filter(x=>x.codPrecioMueble === muebleId)[0][field] = value
				notificationRef.current.addNotification("Campo actualizado correctamente.", "success");
				return true // Devolvemos true para indicar éxito
			} else {
				console.error("Error en la respuesta:", response)
				notificationRef.current.addNotification(
					"Error al actualizar el campo.",
					"error"
				)
				return false // Devolvemos false para indicar fallo
			}
		} catch (error) {
			console.error("Error al actualizar el campo:", error)
			notificationRef.current.addNotification(
				"Error al actualizar el campo.",
				"error"
			)
			return false // Devolvemos false para indicar fallo
		}
	}

	const handleEnviarInformes = async () => {
		const api = getApiInstance()
		try {
			if (selectedSolicitudes.length > 0) {
				const originalSelectedCount = selectedSolicitudes.length

				// Filtrar las solicitudes seleccionadas que cumplen con las columnas requeridas
				const validSolicitudes = solicitudes.filter(
					(solicitud) =>
						selectedSolicitudes.includes(solicitud.codPrecioMueble) &&
						isSelectable(solicitud)
				)

				if (validSolicitudes.length === 0) {
					notificationRef.current.addNotification(
						"No hay solicitudes válidas para enviar.",
						"error"
					)
					return
				}

				// Actualizar selectedSolicitudes para remover las que no cumplen
				setSelectedSolicitudes(
					validSolicitudes.map((solicitud) => solicitud.codPrecioMueble)
				)

				// Separar las solicitudes en dos grupos según el codEstado
				const solicitudesEstado3 = validSolicitudes.filter(
					(solicitud) => solicitud.codEstado === 4
				)
				const solicitudesOtros = validSolicitudes.filter(
					(solicitud) => solicitud.codEstado !== 4
				)

				// Construir las propuestas en formato KeyValuePair: key = codPrecioMueble, value = tarifaPropuesta (o 0 si no está definida)
				const proposalsEstado3 = solicitudesEstado3.map((solicitud) => ({
					key: solicitud.codPrecioMueble,
					value: solicitud.tarifaPropuesta || 0
				}))

				const proposalsOtros = solicitudesOtros.map((solicitud) => ({
					key: solicitud.codPrecioMueble,
					value: solicitud.tarifaPropuesta || 0
				}))

				// CodEstado 5: Informado Revisión para solicitudes con codEstado 4
				if (proposalsEstado3.length > 0) {
					await api.put(
						`/api/MueblesPrecios/update-estados?codEstado=5`,
						proposalsEstado3
					)
				}

				// CodEstado 2: Informado para el resto de solicitudes
				if (proposalsOtros.length > 0) {
					await api.put(
						`/api/MueblesPrecios/update-estados?codEstado=2`,
						proposalsOtros
					)
				}

				if (validSolicitudes.length < originalSelectedCount) {
					notificationRef.current.addNotification(
						"Solicitudes actualizadas correctamente. Algunas solicitudes fueron omitidas por no tener todos los campos requeridos.",
						"info"
					)
				} else {
					notificationRef.current.addNotification(
						"Solicitudes actualizadas correctamente.",
						"success"
					)
				}
				fetchSolicitudes()
			}
		} catch (error) {
			console.error("Error en actualización masiva:", error)
			notificationRef.current.addNotification(
				"Hubo un error al actualizar la solicitud.",
				"error"
			)
		}
	}

	const isSelectable = (row) => {
		if (statesNoEdit.length > 0 && statesNoEdit.includes(row.codEstado)) {
			return false
		}
		const requiredColumns = columnsTarifas.filter((col) => col.required)
		return requiredColumns.every(
			(col) =>
				row[col.key] !== undefined &&
				row[col.key] !== null &&
				row[col.key] !== "" &&
				row[col.key] !== 0
		)
	}

	const handleOpenEditSolicitud = (solicitud) => {
		setEditSolicitud({
			codPrecioMueble: solicitud.codPrecioMueble,
			prototipo: solicitud.prototipo,
			precioUnidadIgnifugo: solicitud.precioUnidadIgnifugo,
			precioMasivo: solicitud.precioMasivo,
			cantidadPedidoMasivo: solicitud.cantidadPedidoMasivo,
			costeFabricacion: solicitud.costeFabricacion,
			costeMateriales: solicitud.costeMateriales,
			costeMaquinaria: solicitud.costeMaquinaria,
			costeManoObra: solicitud.costeManoObra,
			porcentajeBeneficioSobreCoste: solicitud.porcentajeBeneficioSobreCoste,
			codEstado: solicitud.codEstado
		})
		setIsModalOpen(true)
	}

	const closeModal = () => {
		setIsModalOpen(false)
	}

	const handleEditSolicitud = async () => {
		const api = getApiInstance()
		const muebleId = editSolicitud.codPrecioMueble

		// Construimos el documento JSON Patch con todas las operaciones "replace"
		const patchDoc = [
			{
				op: "replace",
				path: "/prototipo",
				value: editSolicitud.prototipo
			},
			{
				op: "replace",
				path: "/precioUnidadIgnifugo",
				value: editSolicitud.precioUnidadIgnifugo
			},
			{
				op: "replace",
				path: "/precioMasivo",
				value: editSolicitud.precioMasivo
			},
			{
				op: "replace",
				path: "/cantidadPedidoMasivo",
				value: editSolicitud.cantidadPedidoMasivo
			},
			{
				op: "replace",
				path: "/costeFabricacion",
				value: editSolicitud.costeFabricacion
			},
			{
				op: "replace",
				path: "/costeMateriales",
				value: editSolicitud.costeMateriales
			},
			{
				op: "replace",
				path: "/costeMaquinaria",
				value: editSolicitud.costeMaquinaria
			},
			{
				op: "replace",
				path: "/costeManoObra",
				value: editSolicitud.costeManoObra
			},
			{
				op: "replace",
				path: "/porcentajeBeneficioSobreCoste",
				value: editSolicitud.porcentajeBeneficioSobreCoste
			}
		]

		if (
			editSolicitud.costeFabricacion !== 0 &&
			editSolicitud.costeMateriales !== 0 &&
			editSolicitud.costeMaquinaria !== 0 &&
			editSolicitud.costeManoObra !== 0 &&
			editSolicitud.porcentajeBeneficioSobreCoste !== 0
		) {
			const precioUnidad =
				(editSolicitud.costeFabricacion +
					editSolicitud.costeMateriales +
					editSolicitud.costeMaquinaria +
					editSolicitud.costeManoObra) *
				(1 + editSolicitud.porcentajeBeneficioSobreCoste / 100)
			patchDoc.push({
				op: "replace",
				path: "/precioUnidad",
				value: precioUnidad
			})
		}

		try {
			console.log("Actualizando solicitud con patch:", patchDoc)
			const response = await api.patch(
				`/api/MueblesPrecios/${muebleId}`,
				patchDoc,
				{
					headers: {
						"Content-Type": "application/json-patch+json"
					}
				}
			)

			if (response.status >= 200 && response.status < 300) {
				// Notificación de éxito
				notificationRef.current.addNotification(
					"Solicitud actualizada correctamente.",
					"success"
				)
				setIsModalOpen(false)
				fetchSolicitudes()
			} else {
				console.error("Error en la respuesta:", response)
				notificationRef.current.addNotification(
					"Error al actualizar la solicitud.",
					"error"
				)
				return false
			}
		} catch (error) {
			console.error("Error al actualizar la solicitud:", error)
			notificationRef.current.addNotification(
				"Error al actualizar la solicitud.",
				"error"
			)
			return false
		}
	}

	const handleSelecteMueble = (selectedIds) => {
		setUsedFilter("mueble")
		setFilterMuebles(selectedIds)
	}

	const handleSelectNombreTarifa = (selectedIds) => {
		setUsedFilter("nombreTarifa")
		setFilterNombreTarifa(selectedIds)
	}

	const handleSelectEstado = (estadoName) => {
		setUsedFilter("estado")
		setFilterEstado((prevSelected) => {
			// Verificar si el estado ya está en la lista
			if (prevSelected.includes(estadoName)) {
				// Si ya está en la lista, eliminarla
				return prevSelected.filter((estado) => estado !== estadoName)
			} else {
				// Si no está, agregarla
				return [...prevSelected, estadoName]
			}
		})
	}

	const handleCleanFilter = () => {
		setFilterMuebles([])
		setFilterNombreTarifa([])
		setFilterEstado([])
		setFilterDiasRestantes([])
		setFilterFechaInformado([])
	}

	const handleExportExcel = async () => {
		try {
			if (selectedSolicitudes.length === 0) {
				notificationRef.current.addNotification(
					"No hay solicitudes seleccionadas para exportar.",
					"warning"
				)
				return
			}
			const api = getApiInstance()
			const response = await api.post(
				`/api/MueblesPrecios/ExportarMisTarifasPendientesExcel/${user.codEmpresa}`,
				selectedSolicitudes,
				{ responseType: "blob" }
			)

			if (response.status !== 200) {
				throw new Error("Error al descargar el archivo")
			}

			// Se obtiene el blob (archivo binario) del response
			const blob = await response.data

			// Se crea un objeto URL para el blob
			const url = window.URL.createObjectURL(blob)

			// Se crea un enlace temporal para simular el click y forzar la descarga
			const a = document.createElement("a")
			a.href = url

			// Intenta extraer el nombre de archivo desde el header Content-Disposition
			let fileName = "MisTarifasPendientes.xlsx"
			const disposition = response.headers.get("Content-Disposition")
			if (disposition && disposition.indexOf("filename=") !== -1) {
				const fileNameMatch = disposition.match(/filename="?([^"]+)"?/)
				if (fileNameMatch && fileNameMatch.length > 1) {
					fileName = fileNameMatch[1]
				}
			}
			a.download = fileName
			document.body.appendChild(a)
			a.click()

			// Se elimina el enlace y se revoca el objeto URL para liberar memoria
			a.remove()
			window.URL.revokeObjectURL(url)

			notificationRef.current.addNotification(
				"Archivo descargado correctamente.",
				"success"
			)
		} catch (error) {
			notificationRef.current.addNotification(
				"Error al descargar el archivo.",
				"error"
			)
			console.error("Error al descargar el archivo:", error)
		}
	}

	const handleDownloadPlantilla = async () => {
		try {
			const api = getApiInstance()
			const response = await api.get(
				"/api/MueblesPrecios/DescargarPlantillaTarifasExcel",
				{
					responseType: "blob"
				}
			)

			const blob = new Blob([response.data], {
				type: response.headers["content-type"]
			})
			const url = window.URL.createObjectURL(blob)

			const link = document.createElement("a")
			link.href = url
			link.setAttribute("download", "Plantilla_Tarifas.xlsx")
			document.body.appendChild(link)
			link.click()
			link.remove()
		} catch (error) {
			console.error("Error al descargar plantilla:", error)
			notificationRef.current.addNotification(
				"Error al descargar la plantilla",
				"error"
			)
		}
	}

	const handleImportExcel = async (event) => {
		const file = event.target.files[0]
		if (!file) return

		const formData = new FormData()
		formData.append("archivoExcel", file)

		try {
			const api = getApiInstance()
			const response = await api.post(
				`/api/MueblesPrecios/ImportarTarifasDesdeExcel?codEmpresa=${user.codEmpresa}`,
				formData
			)
			notificationRef.current.addNotification(response.data, "success")
			await fetchSolicitudes()
		} catch (error) {
			const mensaje =
				error.response?.data || "Error al importar tarifas desde Excel."
			notificationRef.current.addNotification(mensaje, "error")
		}
	}

const handleSearch = (query) => {
	if (!query.trim()) {
		setFilteredSolicitudes(solicitudes);
		return;
	}

	const resultados = searchByKeywords(solicitudes, query, [
		"referencia",
		"nombreMueble",
		"familia",
		"nombreSubfamilia",
		"nombreTarifa",
		"nombreEmpresa"
	]);

	setFilteredSolicitudes(resultados);
};


	const visibleSolicitudes = useMemo(() => {
	let filtered = filteredSolicitudes;

	// Filtro por Variante
	if (filterMuebles.length > 0) {
		filtered = filtered.filter((solicitud) =>
			filterMuebles.includes(solicitud.codMueble)
		);
	}

	// Filtro por Nombre Tarifa
	if (filterNombreTarifa.length > 0) {
		filtered = filtered.filter((solicitud) =>
			filterNombreTarifa.includes(solicitud.nombreTarifa)
		);
	}

	// Filtro por Estado
	if (filterEstado.length > 0) {
		filtered = filtered.filter((solicitud) =>
			filterEstado.map((estado) => estado.id).includes(solicitud.estado)
		);
	}

	// Filtro por Días Restantes
	if (
		filterDiasRestantes.length === 2 &&
		filterDiasRestantes[0] !== "" &&
		filterDiasRestantes[1] !== ""
	) {
		const minDias = parseInt(filterDiasRestantes[0], 10);
		const maxDias = parseInt(filterDiasRestantes[1], 10);
		filtered = filtered.filter(
			(solicitud) =>
				solicitud.diasRestantes >= minDias &&
				solicitud.diasRestantes <= maxDias
		);
	}

	// Filtro por Fecha Informado
	if (
		filterFechaInformado.length === 2 &&
		filterFechaInformado[0] !== "" &&
		filterFechaInformado[1] !== ""
	) {
		const startDate = new Date(filterFechaInformado[0]);
		const endDate = new Date(filterFechaInformado[1]);
		filtered = filtered.filter((solicitud) => {
			if (!solicitud.fechaInformado) return false;
			const fecha = new Date(solicitud.fechaInformado);
			return fecha >= startDate && fecha <= endDate;
		});
	}

	//Filtro por Fecha Solicitado
	if (filterFechaSolicitud.startDate && filterFechaSolicitud.endDate) {
	filtered = filtered.filter((solicitud) => {
		if (!solicitud.fechaSolicitud) return false;

		const fechaSolicitud = new Date(solicitud.fechaSolicitud);
		fechaSolicitud.setHours(0, 0, 0, 0);

		const startDate = new Date(filterFechaSolicitud.startDate);
		startDate.setHours(0, 0, 0, 0);

		const endDate = new Date(filterFechaSolicitud.endDate);
		endDate.setHours(23, 59, 59, 999);

		return fechaSolicitud >= startDate && fechaSolicitud <= endDate;
	});
}


	return filtered;
}, [
	filteredSolicitudes,
	filterMuebles,
	filterNombreTarifa,
	filterEstado,
	filterDiasRestantes,
	filterFechaInformado,
	filterFechaSolicitud
]);

const handleSelectCategoria = (categoriaName) => {
        setUsedFilter("categoria");
        setFilterCategoria((prevSelected) => {
            if (prevSelected.includes(categoriaName)) {
                return prevSelected.filter(
                    (categoria) => categoria !== categoriaName
                );
            } else {
                return [...prevSelected, categoriaName];
            }
        });
    };

    const handleSelectSubcategoria = (subcategoriaName) => {
        setUsedFilter("subcategoria");
        setFilterSubcategoria((prevSelected) => {
            if (prevSelected.includes(subcategoriaName)) {
                return prevSelected.filter(
                    (subcategoria) => subcategoria !== subcategoriaName
                );
            } else {
                return [...prevSelected, subcategoriaName];
            }
        });
    };


	return (
		<section className="dashboard-usuarios">
			<div className="dashboard-usuarios__content__table-header">
				<InputSearch
					context="tableSearch"
					placeholder="Buscar..."
					onSearch={handleSearch}
				/>

				<Button
					variant="outline"
					label="Filtros"
					icon={<FiFilter />}
					onClick={() => setIsFiltersModalOpen(true)}
				/>

				{!tableEditMode ? (
					<Button
						onClick={() => setTableEditMode(true)}
						label="Editar Tabla"
						variant="filled"
					></Button>
				) : (
					<Button
						onClick={() => setTableEditMode(false)}
						aria-label="Guardar cambios de la tabla"
						label="Salir del modo edición"
						variant="filled"
					></Button>
				)}

				<Button
					label="Enviar tarifas"
					icon={<TbLocationDollar />}
					variant="outline"
					onClick={handleEnviarInformes}
				/>
				<Button
					label="Exportar"
					variant="outline"
					icon={<BiExport />}
					onClick={handleExportExcel}
					disabled={selectedSolicitudes.length === 0}
				/>
				<>
					<input
						type="file"
						id="input-import-tarifas"
						accept=".xlsx, .xls"
						style={{ display: "none" }}
						onChange={handleImportExcel}
					/>
					<Button
						label="Importar"
						variant="outline"
						icon={<BiImport />}
						onClick={() =>
							document.getElementById("input-import-tarifas").click()
						}
					/>
				</>
			</div>

			<TableEditable
				columns={columnsTarifas}
				data={visibleSolicitudes}
				noResultsMessage="No hay solicitudes de tarifas pendientes."
				tableEditMode={tableEditMode}
				setTableEditMode={setTableEditMode}
				onCellEdit={handlePatchCellUpdate}
				onUpdate={handleBulkUpdate}
				setData={setSolicitudes}
				rowKey="codPrecioMueble"
				onRowSelect={setSelectedSolicitudes}
				selectedRows={selectedSolicitudes}
				notificationRef={notificationRef}
				statesRestrictEdit={statesNoEdit}
			/>

			<Modal
				title="Filtros"
				isOpen={isFiltersModalOpen}
				onClose={() => setIsFiltersModalOpen(false)}
				onAccept={() => setIsFiltersModalOpen(false)}
				outlineButtonLabel="Limpiar"
				primaryButtonLabel={`Ver resultados (${visibleSolicitudes.length})`}
				onCancel={handleCleanFilter}
			>
				<div className="section-header__modal__section">
					<InputDropdown
						label="Mueble"
						options={mueblesOptions.map((mueble) => ({
							label: mueble.nombre,
							value: mueble.id
						}))}
						onSelect={handleSelecteMueble}
						withCheckboxes={true}
						hasSearch={true}
					/>
				</div>
				{/* NUEVO: Filtro para Nombre Tarifa */}
				<div className="section-header__modal__section">
					<InputDropdown
						label="Nombre Tarifa"
						options={tarifasOptions.map((tarifa) => ({
							label: tarifa.nombre,
							value: tarifa.id
						}))}
						onSelect={handleSelectNombreTarifa}
						withCheckboxes={true}
						hasSearch={true}
					/>
				</div>
				<div className="section-header__modal__section">
					<DateRangeCalendar
						label="Fecha de Solicitud"
						onAccept={(range) => {
							setFilterFechaSolicitud({
								startDate: range.start,
								endDate: range.end,
							});
						}}
						onClear={() => {
							setFilterFechaSolicitud({});
						}}
						initialStartDate={filterFechaSolicitud.startDate}
						initialEndDate={filterFechaSolicitud.endDate}
					/>
				</div>
				{/* <div className="section-header__modal__section">
					<Accordion title="Categoría">
						<ul className="section-header__modal__section__content">
							{categorias.map((categoria, index) => (
								<Tag
									key={index}
									label={categoria}
									isSelected={filterCategoria.includes(
										categoria
									)}
									onSelect={handleSelectCategoria}
								/>
							))}
						</ul>
					</Accordion>
				</div>

				<div className="section-header__modal__section">
					<Accordion title="Subcategoría">
						<ul className="section-header__modal__section__content">
							{subCategorias.map((subcategoria, index) => (
								<Tag
									key={index}
									label={subcategoria}
									isSelected={filterSubcategoria.includes(
										subcategoria
									)}
									onSelect={handleSelectSubcategoria}
								/>
							))}
						</ul>
					</Accordion>
				</div> */}
				<div className="section-header__modal__section">
					<Accordion title="Estado">
						<ul className="section-header__modal__section__content">
							{estadosOptions.map((estado) => (
								<Tag
									key={estado.id}
									label={estado.nombre}
									isSelected={filterEstado.includes(estado)}
									onSelect={() => handleSelectEstado(estado)}
								/>
							))}
						</ul>
					</Accordion>
				</div>
				{/* <div className="section-header__modal__section">
								<InputDropdown
									label="Comparativa"
									options={[
										{ label: "Precio más bajo", value: "bajo" },
										{ label: "Diferencia porcentual", value: "diferencia" }
									]}
									onSelect={handleSelectComparativa}
									withCheckboxes={false}
									hasSearch={false}
								/>
							</div> */}
				{/* <div className="section-header__modal__section">
								<Input
									label="Días Restantes (mínimo)"
									type="number"
									placeholder="Min"
									value={filterDiasRestantes[0] || ""}
									onChange={(e) => handleChangeDiasRestantes(0, e.target.value)}
								/>
								<Input
									label="Días Restantes (máximo)"
									type="number"
									placeholder="Max"
									value={filterDiasRestantes[1] || ""}
									onChange={(e) => handleChangeDiasRestantes(1, e.target.value)}
								/>
							</div> */}
				{/* <div className="section-header__modal__section">
								<Input
									label="Fecha Informado - Desde"
									type="date"
									value={filterFechaInformado[0] || ""}
									onChange={(e) => handleChangeFechaInformado(0, e.target.value)}
								/>
								<Input
									label="Fecha Informado - Hasta"
									type="date"
									value={filterFechaInformado[1] || ""}
									onChange={(e) => handleChangeFechaInformado(1, e.target.value)}
								/>
							</div> */}
			</Modal>

			<Modal
				title="Precios desglosados"
				isOpen={isModalOpen}
				onClose={closeModal}
				outlineButtonLabel="Cancelar"
				primaryButtonLabel="Guardar datos"
				onAccept={
					statesNoEdit.includes(editSolicitud?.codEstado)
						? null
						: handleEditSolicitud
				}
			>
				<div className="dashboard-usuarios__modal">
					<form
						className="dashboard-usuarios__modal__content"
						autoComplete="off"
					>
						<Input
							label="Prototipo"
							value={editSolicitud?.prototipo}
							onChange={(e) =>
								setEditSolicitud({
									...editSolicitud,
									prototipo: e.target.value
								})
							}
							disabled={statesNoEdit.includes(editSolicitud?.codEstado)}
						/>
						<Input
							label="Precio Unidad Ignífugo"
							value={editSolicitud?.precioUnidadIgnifugo}
							onChange={(e) =>
								setEditSolicitud({
									...editSolicitud,
									precioUnidadIgnifugo: e.target.value
								})
							}
							disabled={statesNoEdit.includes(editSolicitud?.codEstado)}
						/>
						<Input
							label="Precio Masivo"
							value={editSolicitud?.precioMasivo}
							onChange={(e) =>
								setEditSolicitud({
									...editSolicitud,
									precioMasivo: e.target.value
								})
							}
							disabled={statesNoEdit.includes(editSolicitud?.codEstado)}
						/>
						<Input
							label="Cantidad Pedido Masivo"
							value={editSolicitud?.cantidadPedidoMasivo}
							onChange={(e) =>
								setEditSolicitud({
									...editSolicitud,
									cantidadPedidoMasivo: e.target.value
								})
							}
							disabled={statesNoEdit.includes(editSolicitud?.codEstado)}
						/>
						<Input
							label="Coste Fabricación"
							value={editSolicitud?.costeFabricacion}
							onChange={(e) =>
								setEditSolicitud({
									...editSolicitud,
									costeFabricacion: e.target.value
								})
							}
							disabled={statesNoEdit.includes(editSolicitud?.codEstado)}
						/>
						<Input
							label="Coste Materiales"
							value={editSolicitud?.costeMateriales}
							onChange={(e) =>
								setEditSolicitud({
									...editSolicitud,
									costeMateriales: e.target.value
								})
							}
							disabled={statesNoEdit.includes(editSolicitud?.codEstado)}
						/>
						<Input
							label="Coste Maquinaria"
							value={editSolicitud?.costeMaquinaria}
							onChange={(e) =>
								setEditSolicitud({
									...editSolicitud,
									costeMaquinaria: e.target.value
								})
							}
							disabled={statesNoEdit.includes(editSolicitud?.codEstado)}
						/>
						<Input
							label="Coste Mano Obra"
							value={editSolicitud?.costeManoObra}
							onChange={(e) =>
								setEditSolicitud({
									...editSolicitud,
									costeManoObra: e.target.value
								})
							}
							disabled={statesNoEdit.includes(editSolicitud?.codEstado)}
						/>
						<Input
							label="Porcentaje Beneficio Sobre Coste"
							value={editSolicitud?.porcentajeBeneficioSobreCoste}
							onChange={(e) =>
								setEditSolicitud({
									...editSolicitud,
									porcentajeBeneficioSobreCoste: e.target.value
								})
							}
							disabled={statesNoEdit.includes(editSolicitud?.codEstado)}
						/>
					</form>
				</div>
			</Modal>

			{/* {isPopupOpen && (
                <Popup
                    type="alert"
                    alertType="warning"
                    titleMessage="Confirmar eliminación"
                    alertMessage="¿Estás seguro de que deseas eliminar este elemento?"
                    onConfirm={handleConfirmDelete}
                    onClose={handleCancelDelete}
                    confirmLabel="Eliminar"
                    cancelLabel="Cancelar"
                />
            )} */}

			<Notification ref={notificationRef} />
		</section>
	)
}